var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FieldsList',{attrs:{"aut-application-fields":"","domain":true},on:{"update":_vm.saveFieldsSettingsToDomain}})}
var staticRenderFns = []

export { render, staticRenderFns }